import Card from '@mui/material/Card';
import { makeStyles } from '@material-ui/styles';
import axios from 'src/utils/axios';
import React, { useEffect, useState } from 'react';
import {
  Box,
  CardContent,
  IconButton,
  Tooltip,
  Grid,
  Divider,
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  Snackbar,
  Typography
} from '@material-ui/core';
import Alert from 'src/components/Alert';
import PlusOneIcon from '@material-ui/icons/PlusOne';
import { confirmAlert } from 'react-confirm-alert';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from 'moment';
import { DataGrid, trTR } from '@mui/x-data-grid';

const useStyles = makeStyles(theme => ({
  root: {
    fontFamily: 'Segoe UI',
    width: '100%',
    height: '100%'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#FFA500'
  },
  tableCell: {
    border: '1px solid #ddd',
    color: '#fff',
    backgroundColor: '#0033a0',
    align: 'left',
    cursor: 'pointer'
  },
  sortHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  icon: {
    fontSize: '1rem'
  },
  tableHead: {
    overflowWrap: 'break-word'
  }
}));

function SarisDynamicProduct() {
  const classes = useStyles();

  const [dynamicReportData, setDynamicReportData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [productName, setProductName] = React.useState('');
  const [description, setDescription] = React.useState('');
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });

  useEffect(() => {
    handleGetSarisDynamicProduct();
  }, []);

  const handleGetSarisDynamicProduct = () => {
    setLoading(true);
    axios
      .get(`GetSarisDynamicProduct`)
      .then(response => {
        setLoading(false);
        var data = response.data;
        setDynamicReportData(data);
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const deleteDynamicProduct = (UrunKod, KulUrunKod, Acıklama) => {
    confirmAlert({
      message: 'Silmek istediğinizde emin misiniz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => {
            handleDeleteDynamicProduct(UrunKod, KulUrunKod, Acıklama);
          }
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  const handleDeleteDynamicProduct = (UrunKod, KulUrunKod, Acıklama) => {
    setLoading(true);
    const encodedAciklama = Acıklama.toString();
    axios
      .get(
        `SetSarisDynamicProductDelete/${UrunKod}/${KulUrunKod}/${encodedAciklama}`
      )
      .then(response => {
        setLoading(false);
        var data = response.data;
        if (data.ErrorCode == '1000') {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('error');
          setUyari(true);
          return;
        } else {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('success');
          setUyari(true);
          handleGetSarisDynamicProduct();
          return;
        }
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const HandleInsertProduct = () => {
    setLoading(true);
    axios
      .get(`SetSarisDynamicNewProduct/${productName}/${description}`)
      .then(response => {
        var data = response.data;
        setLoading(false);
        if (data.ErrorCode == '1000') {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('error');
          setUyari(true);
          return;
        } else {
          HandleResertAndClose();
          handleGetSarisDynamicProduct();
          setresponseMessage(data.ErrorDescription);
          setUyariTip('success');
          setUyari(true);
          return;
        }
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  function HandleResertAndClose() {
    setProductName('');
    setDescription('');
  }

  const columns = [
    {
      field: 'KUL_URUN_KODU',
      headerName: 'Ürün',
      width: 300,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'ACIKLAMA',
      headerName: 'Açıklama',
      width: 400,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'KUL_KODU',
      headerName: 'Sistem Kodu',
      width: 350,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'ADSOYAD',
      headerName: 'Kullanıcı',
      width: 300,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'TARIH',
      headerName: 'Oluşturulma Tarihi',
      width: 400,
      headerAlign: 'center',
      align: 'center',
      sortComparator: (v1, v2) => {
        const date1 = new Date(v1).getTime();
        const date2 = new Date(v2).getTime();
        return date1 - date2;
      },
      renderCell: params => {
        return moment(params.value).format('DD/MM/YYYY HH:mm:ss');
      }
    },
    {
      field: 'Sil',
      headerAlign: 'center',
      align: 'center',
      renderCell: cellValues => {
        return (
          <Box sx={{ justifyContent: 'center', '& > :not(style)': { m: 1 } }}>
            <Tooltip title="sil">
              <IconButton>
                <DeleteIcon
                  style={{ color: '#FF9800' }}
                  onClick={() =>
                    deleteDynamicProduct(
                      cellValues?.row?.URUN_KODU.toString(),
                      cellValues?.row?.KUL_URUN_KODU.toString(),
                      cellValues?.row?.ACIKLAMA.toString()
                    )
                  }
                />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
      width: 100
    }
  ];

  return (
    <>
      <Snackbar
        open={uyari}
        autoHideDuration={5000}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={uyariKapat}
          variant={uyariTip}
          message={responseMessage}
        ></Alert>
      </Snackbar>
      <Card>
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <CardContent>
          <br></br>
          <br></br>
          <Grid container justifyContent="center">
            <Divider style={{ margin: '1rem' }} />
            <Typography
              align="center"
              style={{
                marginBottom: '1rem',
                color: '#FF9800',
                fontWeight: 'bold',
                fontSize: '1.2rem'
              }}
            >
              Yeni Giriş
            </Typography>
            <Divider style={{ margin: '1rem' }} />
            <Grid container spacing={2}>
              <Grid item xs={3}></Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Ürün Adı"
                  variant="outlined"
                  size="small"
                  value={productName}
                  onChange={e => setProductName(e.target.value)}
                />
              </Grid>
              <Grid item xs={3}></Grid>
              <Grid item xs={3}></Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Açıklama"
                  variant="outlined"
                  size="small"
                  multiline
                  rows={4}
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                />
              </Grid>
              <Grid item xs={3}></Grid>
              <br></br>
              <br></br>
              <Grid item xs={3}></Grid>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth
                  startIcon={<PlusOneIcon />}
                  onClick={() => {
                    HandleInsertProduct();
                  }}
                >
                  Ekle
                </Button>
              </Grid>
              <Grid item xs={3}></Grid>
            </Grid>
          </Grid>
          <br></br>
          <br></br>
          <Grid item xs={12}>
            <DataGrid
              rows={dynamicReportData || []}
              columns={columns}
              getRowId={rows => rows.URUN_KODU}
              style={{
                height: 600,
                width: '100%',
                textAlign: 'center',
                justifyItems: 'center'
              }}
            />
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}

export default SarisDynamicProduct;
